import React, {useContext, ReactNode, ReactElement} from 'react';
import {cx} from '@emotion/css';
import {useIntl} from 'react-intl';
import DeviceContext, {Device} from '../../../../../RootProvider/DeviceContext';
import TrustpilotWidget from '../../../TrustpilotWidget/TrustpilotWidget';
import SidebarAdvantage from './Advantage';
import PartnerLogo, {Props as PartnerLogoProps} from '../../../PartnerLogo/PartnerLogo';
import BankingPartnerSection, {Size} from '../../../BankingPartnerSection/BankingPartnerSection';
import {Alignment} from '../../../../../types';

import styles from './Sidebar.styles';

export interface Props {
  partner?: PartnerLogoProps;
  advantages?: string[];
  sideBarBottomComponent?: ReactNode;
  hideAdvantages?: boolean;
}

const Sidebar = ({partner, advantages, sideBarBottomComponent, hideAdvantages = false}: Props): ReactElement => {
  const {formatMessage} = useIntl();
  const currentDevice = useContext(DeviceContext);
  const isDesktop = currentDevice === Device.DESKTOP;

  const defaultAdvantages = [
    formatMessage({id: 'phoenix.layoutSectionSidebar.advantage.creditScore'}),
    formatMessage({id: 'phoenix.layoutSectionSidebar.advantage.financeSpecialist'}),
    formatMessage({id: 'phoenix.layoutSectionSidebar.advantage.results'}),
  ];
  const advantagesOnPage = advantages || defaultAdvantages;

  return (
    <div className={cx('layoutSectionSidebar', styles.sidebar)}>
      <div className={cx(styles.sidebarInner)}>
        {isDesktop && partner && <PartnerLogo name={partner.name} logoUrl={partner.logoUrl} />}

        {!hideAdvantages && isDesktop && advantagesOnPage && (
          <ul className={cx(styles.advantages)} data-testid="ui.sidebar.advantages">
            {advantagesOnPage.map((text, i) => (
              <SidebarAdvantage key={`advantage_${i.toString()}`} text={text} />
            ))}
          </ul>
        )}

        <div className={cx(styles.trustpilot)} data-testid="ui.sidebar.trustpilot">
          <TrustpilotWidget />
        </div>

        <BankingPartnerSection hideText size={Size.MEDIUM} alignment={Alignment.LEFT} />

        {isDesktop && (
          <div className={cx(styles.bottom)} data-testid="ui.sidebar.bottom.component">
            {sideBarBottomComponent}
          </div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
